import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import TheatreSidebar from "../Layouts/TheatreSidebar";

import axios from "axios";
import $ from "jquery";

export class NewSurgery extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      DateofSurgery: "",
      Diagnosis: "",
      Surgeryperformed: "",
      Surgeon: "",
      CategoryElective: "",
      CategoryEmergency: "",

      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    $(".deadonehouryes").click(function () {
      $(".deadonereason").show();
    });
    $(".deadonehourno").click(function () {
      $(".deadonereason").hide();
    });

    $(".stillbirthyes").click(function () {
      $(".stillbirthtype").show();
    });
    $(".stillbirthno").click(function () {
      $(".stillbirthtype").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(this.state);
    axios
      .post(
        this.api_url+"optheatre/newsurgery/labour",
        this.state,
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          localStorage.setItem("surgeryid", response.data["surgeryid"]);
          $(".alert-success").show();
        }

        setTimeout(function () {
          window.location.href = "/theatre/operating/delivery";
        }, 500);

        //
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      DateofSurgery,
      Diagnosis,
      Surgeryperformed,
      Surgeon,
      CategoryElective,
      CategoryEmergency,
    } = this.state;
    return (
      <div>
        <Headers />
        <TheatreSidebar />

        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2"></div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    New Surgery
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      DateofSurgery
                    </h6>
                    <input
                      type="date"
                      className="form-control"
                      onChange={this.handleChange}
                      value={DateofSurgery}
                      name="DateofSurgery"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Diagnosis
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Diagnosis}
                      name="Diagnosis"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      CategoryEmergency
                    </h6>
                    <input
                      onChange={this.handleChange}
                      value={CategoryEmergency}
                      name="CategoryEmergency"
                      className="form-control"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Surgeryperformed
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Surgeryperformed}
                      name="Surgeryperformed"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Surgeon
                    </h6>
                    <input
                      onChange={this.handleChange}
                      value={Surgeon}
                      name="Surgeon"
                      className="form-control"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      CategoryElective
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={CategoryElective}
                      name="CategoryElective"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2"></div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default NewSurgery;
